// © 2015-2021 WDNA - All Rights Reserved
import UserSettings from './Loader';

export const redirects: any[] = [];

export const routes: any[] = [
  {
    component: UserSettings,
    path: '/settings/user',
  }
];
